import { ClientSideError, ClientSideErrorType, logger } from '@dtx-company/logger'
import { SubscriptionStatus } from '../../../types/subService'

const subscriptionStatuses: string[] = Object.values(SubscriptionStatus)
export const toSubscriptionStatus = (jsonStatus: string): SubscriptionStatus => {
  if (!subscriptionStatuses.includes(jsonStatus)) {
    logger.logError(
      new ClientSideError({
        message: `Unknown subscription status: ${jsonStatus}`,
        name: 'UnknownSubscriptionStatus',
        type: ClientSideErrorType.ClientSideValidationError
      }),
      { technicalArea: 'monetization' }
    )
  }
  return jsonStatus as SubscriptionStatus
}
